import { createRouter } from '@tanstack/react-router';
import { routeTree } from '../../routeTree.gen';

export const router = createRouter({
  routeTree,
  // 'intent' (hover/focus) prefetch downloads heavy lazy vendor chunks
  // (vendor-flow, vendor-leaflet, vendor-charts) before the user navigates,
  // which Lighthouse reports as unused JS on every page. Disable — chunks
  // load on navigation which is fast enough with our split strategy.
  defaultPreload: false,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
